import axios from 'axios'

import { flyersApi as baseAPI } from './api'

const baseURL = baseAPI

/**
 * LIST
 */
// export const list = queries => Promise.resolve(listFlyers);
export const list = queries => {
  return axios.get(`${baseURL}`, { params: { ...queries } })
}

/**
 * VIEW
 */
export const get = id => {
  return axios.get(`${baseURL}/${id}`)
}

/**
 * CREATE
 */
export const create = body => {
  return axios.post(`${baseURL}`, body)
}

/**
 * EDIT
 */
export const update = ({ id, body }) => {
  return axios.put(`${baseURL}/${id}`, body)
}

/**
 * DELETE
 */
export const remove = id => {
  return axios.delete(`${baseURL}/${id}`)
}

export default {
  list,
  get,
  create,
  update,
  remove
}
